<div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-10">
      <h2>Customers</h2>

      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a [routerLink]="['/home']">Home</a>
        </li>
        <li class="breadcrumb-item">
          <a>Customers</a>
        </li>
      </ol>
    </div>
  </div>
  
  <div class="wrapper wrapper-content animated fadeInRight">
    <div class="row">
      <div class="col-lg-12">
        <div class="ibox-content">
        
        </div>
      </div>
    </div>
  </div>